import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';
import {
  AbTitle,
  AbSection,
  AbButton,
  AbDescription,
  AbContainer,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import HtmlRenderer from '../../../ui/HtmlRenderer.vue';

interface Props {
  data: {
    id?: string | null;
    text?: string | null;
    image?: string | null;
    title?: string | null;
    button?: {
      link?: string | null;
      text: string;
      target?: '_blank' | '_self' | null;
      isVisible?: true | null;
    } | null;
    imageMobile?: string | null;
    spacing?: Spacing | null;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'HeroSectionBanner',
  props: {
    data: null
  },
  setup(__props: any) {



return { __sfc: true,CdnImg, AbTitle, AbSection, AbButton, AbDescription, AbContainer, HtmlRenderer }
}

})